import type { SvgIconProps } from '@mui/material'
import { Ruler as RulerIcon } from '@phosphor-icons/react/Ruler'

import { createPhoenixIconSet } from '@salsita-ai/platform-project-sdk/ui'

const Ruler = (props: SvgIconProps) => {
  return <RulerIcon {...props} height={props.height ?? 27} width={props.width ?? 27} />
}

createPhoenixIconSet({
  Ruler,
})
